import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';


import * as _ from 'lodash-es';
declare var require: any;

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  monitor: any;
  monitor_id: any;

  view: any;

  passFormGroup = new FormGroup({
    password: new FormControl('',[Validators.required,Validators.minLength(8)])
  });
  passSubmitted = false;

  formGroup = new FormGroup ({
    search: new FormControl('',[]),
    sort: new FormControl('newest',[]),
    companies: new FormControl([],[]),
  });

  submitted = false;

  get f(): { [key: string]: AbstractControl } {
    return this.formGroup.controls;
  }

  get pf(): { [key: string]: AbstractControl } {
    return this.passFormGroup.controls;
  }

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, private transloco: TranslocoService) { }

  ngOnInit(): void {

    this.monitor_id = this.okService.session.id;

    this.getAccount();

  }

  getAccount(){


    //console.log('filter', filter);

    this.okService.get("me",{})
    .subscribe((data) => {

      this.monitor = data.body;

      //console.log("account",data);

    });

  }

  setForm(){
    this.passFormGroup = new FormGroup ({
      password: new FormControl('',[Validators.required])
    });
    this.passSubmitted = false;
  }

  submitPassForm(){

    this.passSubmitted = true;
    if(this.passFormGroup.valid){
      let values = this.passFormGroup.value;
      //console.log('passForm pre-submit',values);


      this.okService.put("password/"+this.monitor_id,values)
      .subscribe({
        next: (data) => {

          this.setForm();

          this.okService.refreshUser();
  
          this.okService.setAlert(this.transloco.translate("Your password has been updated"),"success");

        },
        error: (e) => {

          //console.log("error",e);

          if(Array.isArray(e)){
            let self = this;
            // Use of _.forEach() method
            _.forEach(e, function(error:any) {
              //console.log(error);
              self.passFormGroup.get(error.field)?.setErrors({ invalid: error.message });
            });
          }else{
            this.okService.setAlert(e,"warning")
          }


        },
        complete: () => {
          //console.info('complete');
        }
    });

    }
  }

  changePage(){
    //console.log('page',this.okService.pagination.page);
    this.getAccount();
  }

}
